module.exports = __webpack_public_path__ + "img/wuquanxian.57ed24bc.png";